import { getHelperText } from "ds_legacy/components/Validation";
import {
  FormElementProps,
  FormElementRenderProps,
  isValid,
} from "react-forms-state/src";
import { useTranslations } from "translations";
import { Input, InputProps } from "./input";

export function ConnectedInput({
  debug,
  onChange,
  sideMutation,
  validation,
  value,
  withFlatModel,
  ...inputProps
}: Omit<FormElementProps, "elementName"> & InputProps) {
  const translations = useTranslations();

  return (
    <FormElementRenderProps
      debug={debug}
      elementName={inputProps.name}
      sideMutation={sideMutation}
      validation={validation}
      value={value}
      withFlatModel={withFlatModel}
      onChange={onChange}
    >
      {({ onChange, validation, value }) => {
        return (
          <Input
            {...inputProps}
            errorMessage={
              getHelperText({
                hasCustomValidation: true,
                translations,
                validateOverride: undefined,
                validation,
              }) || inputProps.errorMessage
            }
            isInvalid={!isValid(validation) || inputProps.isInvalid}
            value={value ?? ""}
            onValueChange={(value) => {
              onChange(value);
              inputProps.onValueChange?.(value);
            }}
          />
        );
      }}
    </FormElementRenderProps>
  );
}

ConnectedInput.displayName = "RecareUI.ConnectedInput";
